import React from 'react';
import cx, { Argument as ClassNameType } from 'classnames';

import { Content } from 'LegacySBCRA/Content/Content';

import VehicleHeader from '../../fastlane/vehicleHeaderWrapper/VehicleHeaderWrapper';
import { SWITCH_TIME } from '../VehicleProfiling.constants';

import styles from './QuestionHeader.module.scss';

type QuestionHeaderProps = {
  animateOnEnd?: boolean;
  animateOnStart?:boolean;
  className?: ClassNameType;
  innerClassName?: ClassNameType;
  subtitle?: React.ReactNode;
  title?: React.ReactNode;
  withVehicleDetails?: boolean;
}

const fadeOutTime = ((SWITCH_TIME % 60000) / 1000).toFixed(2);

export const QuestionHeader = ({
  animateOnEnd = false,
  animateOnStart = false,
  className,
  innerClassName,
  subtitle,
  title,
  withVehicleDetails = true,
}: QuestionHeaderProps) => {
  if (!title) {
    return null;
  }

  return (
    <div
      className={cx(styles.component, className, {
        [styles.animate]: animateOnStart,
        [styles.animateEnd]: animateOnEnd,
      })}
      // @ts-expect-error -- TS doesn't know that CSS var is value of React.CSSProperties
      style={{ '--question-header-fade-time': `${fadeOutTime}s` }}
    >
      {withVehicleDetails ? <VehicleHeader link={null} /> : null}
      <Content className={cx(styles.content, innerClassName)}>
        <h2>{title}</h2>
        {subtitle ? <p>{subtitle}</p> : null}
      </Content>
    </div>
  );
};
